import { checkResponse, post, get } from "@/utils/http"
import { APP_CONFIG } from '@/utils/constants'

export function info() {
    let ads = localStorage.getItem('ads');
    let url = `${APP_CONFIG.apiUrl}/auth/info`;

    if (ads) {
        url += `?affiliate=${encodeURIComponent(ads)}`;
    }

    return get(url).then(checkResponse);
}

export function register(data) {
    return post(`${APP_CONFIG.apiUrl}/auth/register`, data)
        .then(checkResponse)
}

export function login(email, password) {
    return post(`${APP_CONFIG.apiUrl}/auth/login`, { email, password })
        .then(checkResponse)
}

export function mobilefone(phone, password) {
    return post(`${APP_CONFIG.apiUrl}/auth/mobilefone`, { phone, password })
        .then(checkResponse)
}

export function forgotPassword(email) {
    return post(`${APP_CONFIG.apiUrl}/auth/forgot-password`, { email })
        .then(checkResponse)
}

export function resetPassword(email, password, verify_code) {
    return post(`${APP_CONFIG.apiUrl}/auth/reset-password`, { email, password, verify_code })
        .then(checkResponse)
}

export function refreshToken(data) {
    return post(`${APP_CONFIG.apiUrl}/auth/token-refresh`, data)
        .then(checkResponse)
}

export function logout() {
    return post(`${APP_CONFIG.apiUrl}/auth/logout`)
        .then(checkResponse)
}
